type Cns = {
  container?: string
  item?: string
  picture?: string
  image?: string
  time?: string
  copy?: string
  colonBox?: string
  colon?: string
}

type Copy = {
  days?: string
  hours?: string
  minutes?: string
  seconds?: string
}

export type CountDownProps = {
  endTime?: string
  copy?: Copy
  cns?: Cns
  expiredHidden?: boolean
}

export type ItemProps = {
  time?: string
  copy?: string
  image?: string
  cns?: Cns
}
